<template>
  <v-app v-if="dataReady">
    <v-progress-linear
      v-if="showSpinner"
      indeterminate
      color="primary"
    />
    <template v-else>
      <navigation
        v-if="showNavigation"
        class="hidden-print-only"
        :is-drawer-collapsible="isDrawerCollapsible"
      />
      <cookie-consent />
      <v-main
        class="grey lighten-4"
        :data-btm-cid="publicCompanyId"
        :class="{'main-collapsed-nav': isDrawerCollapsible && $vuetify.breakpoint.lgAndUp}"
      >
        <slot />
      </v-main>
      <Feature
        v-slot="{feature}"
        :feature-slug="featureNames.FEEDBACK_TICKET"
      >
        <feedback :config="feature.config" />
      </Feature>
    </template>
  </v-app>
</template>

<script>
import Navigation from '@/modules/navigation'
import CookieConsent from '@/modules/cookieConsent'
import { Feature } from 'feature-config'
import featureNames from '@/lib/featureNames'
import Feedback from '@/modules/feedback'
import featureMixin from '@/mixins/feature'
import COMPANY_STATE from '@/guards/CompanyState.gql'

export default {
  components: {
    Navigation,
    CookieConsent,
    Feedback,
    Feature
  },
  mixins: [featureMixin],
  data () {
    return {
      featureNames
    }
  },
  computed: {
    dataReady () {
      const isSignUpFeatureActive = this.isFeatureActive(this.featureNames.SIGNUP)
      return !isSignUpFeatureActive || (isSignUpFeatureActive && this.company)
    },
    showSpinner () {
      return this.$auth.isAuthenticated && !this.$features.loaded && this.$auth.user.companyId
    },
    showNavigation () {
      if (this.$auth?.user?.companyId) {
        const isSignUpFeatureActive = this.isFeatureActive(this.featureNames.SIGNUP)
        if (isSignUpFeatureActive) {
          return !this.company.state.stringValues.includes('SELF_ONBOARDING')
        }
        return true
      }
      return false
    },
    isDrawerCollapsible () {
      return this.$vuetify.breakpoint.mdAndUp && ['/leads'].includes(this.$route.path)
    },
    publicCompanyId () {
      return this.$auth?.user?.companyId
    }
  },
  apollo: {
    company: {
      query: COMPANY_STATE,
      variables () {
        return {
          id: this.$auth.user.companyId
        }
      },
      skip () {
        return this.$auth.loading || !this.$auth.isAuthenticated || !this.$auth.user.companyId || !this.isFeatureActive(this.featureNames.SIGNUP)
      }
    }
  }
}
</script>
<style scoped>
@media print{
.v-main {
    padding: 0 !important;
  }
}
.main-collapsed-nav{
  padding-left: 60px !important;
}
</style>
